import styled from 'styled-components';
import { ButtonLabel, ButtonWrapper } from '@src/styles/styled/mixins';
import { Tabs } from 'antd';

export const DimensionTablesWrapper = styled.div`
  flex-direction: column;
  flex-grow: 1;
  display: flex;
  height: 100%;
`;

export const DimensionWidget = styled.div`
  display: flex;
  flex-direction: column;
`;

// TODO: clean up height wrapping and overflow scroll
export const DimensionWidgetWrapper = styled.div<{ height: string }>`
  display: flex;
  flex-direction: column;
  margin: 0;
  box-sizing: border-box;
  padding: 0;
  flex-grow: 1;
  flex-basis: 100%;
  position: relative;
  min-height: 600px;
  height: ${(props) => props.height};

  .ant-tabs {
    height: ${(props) => props.height};

    .ant-tabs-content-holder {
      height: ${(props) => props.height};

      .ant-tabs-content {
        height: ${(props) => props.height};

        .ant-tabs-tabpane {
          height: ${(props) => props.height};
        }
      }
    }
  }
`;
//  overflow: hidden;

export const DimensionTableContainer = styled.div<{ width: number; horizontalLayout: boolean }>`
  flex-flow: wrap;
  flex-direction: row;
  flex-grow: 1;
  justify-content: space-between;
  height: fit-content;
  margin: 0;
  padding: 0;
  padding-right: 10px;
  box-sizing: border-box;
  overflow: hidden;
  width: auto;
  display: grid;
  grid-template-columns: ${(props) => `repeat(auto-fill,minmax(${props.width}px, 1fr))`};
  grid-auto-rows: 47px;
  gap: 10px;
  ${(props) => (props.horizontalLayout ? `` : `overflow-y: scroll;overflow-x: hidden;`)}
`;

export const HeaderFlexWrap = styled.div<{ $top?: number }>`
  display: flex;
  flex-direction: column;
  position: sticky;
  top: ${({ $top }) => `${($top || 60) + 42}px`};
  z-index: 11;
  margin: 0;
  margin-top: 5px;
  padding: 0;
`;

export const TitleFlexWrap = styled.div`
  flex-grow: 1;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  padding: 2px 0;
  background-color: #f5f5f5;
  margin: 2px 0;
  gap: 5px;
`;

export const ViewToggleWrapper = styled.div`
  padding: 5px;

  input:active + label,
  input:hover + label,
  label:active,
  label:hover {
    border-color: #ddd;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
    width: 0;
  }

  .ant-radio-button-wrapper {
    border: 1px solid #ddd;
  }

  .ant-radio-button-wrapper:focus-within {
    outline: none;
  }
`;

export const ViewerSessionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  min-height: 600px;
  height: 100%;
`;

export const VMTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  padding: 10px;
  gap: 10px;
`;

export const WarningText = styled.div`
  margin: 10px;
  font-size: 16px;
`;

export const StyledImpactedToolbarWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0;
`;

export const StyledBtnWrapper = styled.div`
  ${ButtonWrapper}
`;

export const StyledBtnLabel = styled.div`
  ${ButtonLabel}
`;

export const SliceIntervalWrapper = styled.div<{ color: string }>`
  display: flex;
  align-items: center;
  border: 1px solid #c9cbcd;
  border-radius: 6px;
  border-left: ${(props) => `solid 10px ${props.color}`};
`;

export const SlicePositionWrapper = styled.div<{}>`
  display: flex;
  position: absolute;
  right: 0;
  top: 5px;
  padding-right: 10px;
`;

export const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    margin-bottom: 0;
    border-bottom: 1px solid #e5e5e5;
  }

  .ant-tabs-tab + .ant-tabs-tab {
    margin: 0 0 0 20px;
  }
`;

export const ControlsWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  margin: 0;
`;
